// @ts-nocheck
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import * as PropTypes from 'prop-types';

const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: 'none',
  background: '#ffffff',
  borderRadius: '12px',
  border: isDragging ? '2px solid #98C6F6' : '',
  ...draggableStyle
});

/**
 * Functional React component for rendering a custom draggable element.
 *
 * @namespace Components
 *
 * @param {Object} props - The properties of the component.
 * @param {Object} props.item - Data containing information for the element.
 * @param {string} props.id - The unique identifier for the component.
 *
 * @returns {JSX.Element} - The rendered draggable component.
 */

const DraggableElement = ({ item, index, isDroppable }) => {
  const [isMounted, setIsMounted] = useState(false);
  const isDragging = useSelector((state) => state.library?.isDragging ?? false);
  const isTripDayItemDraggableDisabled = useSelector(
    (state) => state.library?.itinerary?.isTripDayItemDraggableDisabled ?? false
  );

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return (
    <Draggable
      key={`${item.id}`}
      draggableId={`${item.id}`}
      index={index}
      isDragDisabled={item.isDragDisabled || false}
    >
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={getItemStyle(
            snapshot.isDragging,
            provided.draggableProps.style
          )}
        >
          {!isDroppable ? (
            item.content
          ) : (
            <Box key={item.id} className='draggable-list-item'>
              {isMounted && (
                <Droppable
                  droppableId={
                    'TRIP_DAY_DROPPABLE_ID.' + item?.entityId ?? index
                  }
                  isDropDisabled={isTripDayItemDraggableDisabled}
                >
                  {(provided, snapshot) => (
                    <div
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      className={`droppable-container ${snapshot.isDraggingOver || (isDragging && !isTripDayItemDraggableDisabled) ? 'droppable-container--dragging-over' : ''}`}
                    >
                      {item.content}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              )}
            </Box>
          )}
        </div>
      )}
    </Draggable>
  );
};

/**
 * Prop type definitions for DraggableElement.
 */
DraggableElement.propTypes = {
  item: PropTypes.object,
  index: PropTypes.number,
  isDroppable: PropTypes.bool
};

export default DraggableElement;
